module.exports = __webpack_public_path__ + "img/icon_deposit.f4cda85.webp";